import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  tagName: 'i',
  classNames: ['draggable__handle', 'draggable__handle--inline', 'draggable-list__handle'],
  classNameBindings: ['disabled:draggable__handle--disabled']
});